export default "https://legacy.eskolare-development.com/images/address-empty.png";